/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'ai-mate.agent-header-banner-label': "Banner dell'agente",
  'ai-mate.agent-list.all-agents-section-title': 'Tutti gli agenti',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Hai modificato il responsabile di {agentName} in {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Modifica del responsabile riuscita',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Vuoi davvero eliminare questo agente? Questa azione non può essere annullata.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Vuoi eliminare "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': "Impossibile eliminare l'agente",
  'ai-mate.agent-list.delete-agent-error-flag-description':
    "Si è verificato un problema durante l'eliminazione dell'agente. Riprova tra qualche istante.",
  'ai-mate.agent-list.delete-agent-error-flag-title': "Impossibile eliminare l'agente",
  'ai-mate.agent-list.delete-agent-error.agent-in-use': "L'agente è attualmente in uso. Riprova più tardi.",
  'ai-mate.agent-list.delete-agent-error.agent-not-found': "Impossibile trovare l'agente.",
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    "Non puoi eliminare gli agenti che non hai creato in prima persona. Contatta il responsabile dell'agente.",
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Hai eliminato {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agente eliminato',
  'ai-mate.agent-list.development-section-title': 'Agenti di sviluppo',
  'ai-mate.agent-list.recommended-agents-section-title': 'Consigliato',
  'ai-mate.agent-list.templates-description':
    'Usa questi modelli per creare il tuo agente per sviluppatori. Scegli il modello di agente giusto per il tuo lavoro, seleziona Usa modello, quindi compila la richiesta del modello con dettagli specifici, quali repository, cartella, lingua e raccolta. Crea agenti di sviluppo su misura per codificare diversi task, progetti o repository.',
  'ai-mate.agent-list.templates-lozenge-title': 'Modello',
  'ai-mate.agent-list.templates-title': 'Modelli di codifica',
  'ai-mate.agent-message.agent-not-found': 'Agente non trovato',
  'ai-mate.agent-message.convo-title': "Chat con {agentName} attivata dall'integrazione del link intelligente",
  'ai-mate.agent-message.copy-link': "Copia link all'agente",
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Scrivi un messaggio a {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Invia',
  'ai-mate.agent-message.view-profile': 'Visualizza profilo',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Annulla',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Elimina',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agente · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Chatta con {agentName}',
  'ai-mate.agent-profile-info.hidden-icon': 'Nascosto',
  'ai-mate.agent-profile-info.hidden-tooltip': "L'agente non comparirà nei risultati di ricerca",
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Segna agente come preferito',
  'ai-mate.agent-selector.default-agent-description':
    'Ricevi risposte, genera nuove idee e accelera il lavoro quotidiano.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.profile-card-preview.actions-title': 'Azioni',
  'ai-mate.profile-card-preview.agent-default-title': 'Agente',
  'ai-mate.profile-card-preview.agent-description-label': 'Descrizione',
  'ai-mate.profile-card-preview.agent-title-label': 'Titolo',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Spunti di conversazione',
  'ai-mate.profile-card-preview.empty-actions': 'Nessuno',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Nessuno',
  'ai-mate.profile-card-preview.empty-instructions': 'Nessuno',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Nessuna selezione',
  'ai-mate.profile-card-preview.instructions-title': 'Istruzioni',
  'ai-mate.profile-card-preview.knowledge-title': 'Conoscenze',
  'ai-mate.profile-card-preview.regenerate-label': 'Rigenera {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - Copia',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Trascina per riordinare',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Impossibile salvare le modifiche',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Si è verificato un errore sconosciuto. Riprova',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Un agente con questo nome è già esistente',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Rimuovi',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Genera gli spunti di conversazione',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} non può contenere più di {maxLength,number} carattere} other {{fieldName} non può contenere più di {maxLength,number} caratteri}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Avanti',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Riavvia',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Passa alla configurazione manuale',
  'create-agent.owner-field.confirm-modal-cancel': 'Annulla',
  'create-agent.owner-field.confirm-modal-confirm': 'Sì, continua',
  'create-agent.owner-field.confirm-modal-content':
    'Stai per cambiare il responsabile di questo agente in {name}. Non sarai più in grado di modificare o gestire questo agente.',
  'create-agent.owner-field.confirm-modal-title': "Stai per perdere l'accesso in modifica",
  'create-agent.owner-field.owner-description': "La persona che può modificare o gestire l'agente.",
  'create-agent.owner-field.owner-label': 'Responsabile',
  'rovo-chat.agent-card.deactivated-name': '{name} (disattivato)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Troppe richieste. Attendi un istante.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Riprova',
  'rovo-chat.browse-agents.all-agents-button': 'Tutti',
  'rovo-chat.browse-agents.close-button': 'Chiudi',
  'rovo-chat.browse-agents.create-agent-button': 'Crea',
  'rovo-chat.browse-agents.create-an-agent-button': 'Crea un agente',
  'rovo-chat.browse-agents.created-by-label': '<text>di</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Agenti di codifica',
  'rovo-chat.browse-agents.favorite-agents-button': 'Preferiti',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agente preferito',
  'rovo-chat.browse-agents.learn-more': 'Scopri di più',
  'rovo-chat.browse-agents.modal-title': 'Sfoglia gli agenti',
  'rovo-chat.browse-agents.my-agents-button': 'I miei agenti',
  'rovo-chat.browse-agents.no-created-agents':
    'Sembra che tu non abbia ancora creato alcun agente. Inizia duplicando altri agenti esistenti o comincia da zero per crearne uno.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Non è ancora stato creato alcun agente',
  'rovo-chat.browse-agents.no-results': 'Nessun risultato',
  'rovo-chat.browse-agents.no-starred-agents':
    'Se hai un agente preferito o che usi spesso, segnalo come preferito per accedervi facilmente.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Non hai ancora segnato un agente come preferito',
  'rovo-chat.browse-agents.search-input.placeholder': 'Cerca gli agenti',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Cerca modelli',
  'rovo-chat.browse-agents.see-all-agents-button': 'Visualizza tutti gli agenti',
  'rovo-chat.browse-agents.starred-agents-button': 'Preferiti',
  'rovo-chat.browse-agents.templates-button': 'Modelli',
  'rovo-chat.create-agent.actions-section-description':
    'Aggiungi azioni per consentire al tuo agente di eseguire task in Jira, Confluence e Jira Service Management. <link>Che cosa sono le azioni degli agenti?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Aggiungi azioni',
  'rovo-chat.create-agent.all-content-label': 'Tutti i contenuti',
  'rovo-chat.create-agent.back-button': 'Torna indietro',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Non hai ancora creato il tuo agente, vuoi eliminarlo?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Annulla',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': "Sì, elimina l'agente",
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Agente incompiuto',
  'rovo-chat.create-agent.confirm-restart-modal.body': 'Vuoi davvero ignorare le modifiche apportate a questo agente?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Conferma',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Riavvia la creazione',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Le persone possono usarli per avviare una chat con il tuo agente. Se non hai idee in merito, possiamo generarli noi per te.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Elementi di avvio delle conversazioni',
  'rovo-chat.create-agent.create-agent-button': 'Crea',
  'rovo-chat.create-agent.ctions-section-title': 'Azioni',
  'rovo-chat.create-agent.description-field-description':
    "Le persone possono utilizzare la descrizione sul profilo dell'agente per saperne di più.",
  'rovo-chat.create-agent.description-field-label': 'Descrizione',
  'rovo-chat.create-agent.description-field-placeholder':
    "Scrivi una breve descrizione dell'agente (ad esempio, autore creativo per blog di marketing)",
  'rovo-chat.create-agent.instructions-field-description':
    'Come vuoi che si comporti questo agente? Cosa può fare? <link>Scopri di più su come scrivere istruzioni per un agente</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Istruzioni',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Personalizza le istruzioni per questo agente',
  'rovo-chat.create-agent.intro-description-part-1':
    'Crea un agente con conoscenze specialistiche per rispondere a domande, scrivere e rivedere contenuti ed eseguire attività che ti aiutino a portare avanti il lavoro.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Se non ti serve aiuto, puoi <bold>passare alla configurazione manuale</bold>.',
  'rovo-chat.create-agent.intro-description-part-3': 'Altrimenti, resta qui per crearne uno insieme.',
  'rovo-chat.create-agent.intro-step-1-content':
    "Creerò le istruzioni per l'agente in base a ciò che scrivi. Dimmi solo per cosa intendi utilizzare l'agente.",
  'rovo-chat.create-agent.intro-step-1-title': 'Descrivi cosa vuoi che faccia il tuo agente',
  'rovo-chat.create-agent.intro-step-2-content':
    'Lavoriamo insieme per decidere il nome e la personalità del tuo agente. Dimmi se il tuo agente è empatico, diretto o divertente.',
  'rovo-chat.create-agent.intro-step-2-title': 'Introduci un personaggio',
  'rovo-chat.create-agent.intro-step-3-content':
    "Clicca su <bold>Avanti</bold> per esaminare il tuo nuovo agente, aggiungere azioni, conoscenze e un'immagine del profilo. Quando hai finito, seleziona <bold>Crea</bold>.",
  'rovo-chat.create-agent.intro-step-3-title': 'Rivedi e crea il tuo agente',
  'rovo-chat.create-agent.intro-title': '👋 Creiamo il tuo agente',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Tutti i progetti',
  'rovo-chat.create-agent.knowledge-field-description':
    "Specifica le conoscenze dell'agente consentendogli di fare riferimento solo alle fonti da te fornite",
  'rovo-chat.create-agent.knowledge-field-label': 'Conoscenze',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Fai riferimento solo a queste fonti',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Suggeriti',
  'rovo-chat.create-agent.manage-actions-button-label': 'Gestisci azioni',
  'rovo-chat.create-agent.name-field-description': "Le persone possono usarlo per trovare l'agente.",
  'rovo-chat.create-agent.name-field-label': 'Nome',
  'rovo-chat.create-agent.name-field-placeholder': "Assegna un nome all'agente",
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'Si è verificato un errore imprevisto. Riprova.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Salve! Sono qui per aiutarti a creare un agente personalizzato. Cosa vorresti che facesse il tuo agente?',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Digita il tuo messaggio',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Invia',
  'rovo-chat.create-agent.page-title': 'Crea un agente',
  'rovo-chat.create-agent.page-title-edit': 'Modifica agente',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Cerca le pagine',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Cerca gli spazi',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Tutti',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Annulla',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Chiudi',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Selezionando meno di {count,number} azione otterrai prestazioni ottimali} other {Selezionando meno di {count,number} azioni otterrai prestazioni ottimali}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Salva',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Cerca azioni',
  'rovo-chat.create-agent.select-action-modal-title': 'Aggiungi azioni',
  'rovo-chat.create-agent.select-content-under-label': 'Seleziona il contenuto in',
  'rovo-chat.create-agent.select-spaces-label': 'Seleziona gli spazi',
  'rovo-chat.create-agent.selected-actions-label': 'Azioni selezionate:',
  'rovo-chat.create-agent.unknown-owner': 'Sconosciuto',
  'rovo-chat.create-agent.update-agent-button': 'Aggiorna',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Continuando perderai le modifiche non salvate. Seleziona Annulla per continuare a modificare questo agente.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Continua e ignora le modifiche',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Ignora le modifiche',
  'rovo-chat.view-agent.about-label': 'Informazioni',
  'rovo-chat.view-agent.actions-label': 'Azioni',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': "Chatta con l'agente",
  'rovo-chat.view-agent.close-button': 'Chiudi',
  'rovo-chat.view-agent.copy-instructions-label': 'Copia',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Copia le istruzioni',
  'rovo-chat.view-agent.created-by-label': '<text>di</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'N. di preferiti',
  'rovo-chat.view-agent.go-back-label': 'Torna indietro',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Le istruzioni degli agenti Forge creati con il codice sono nascoste per motivi di privacy.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Queste istruzioni sono private',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Gli agenti Forge creati con il codice non utilizzano le fonti di conoscenza tipiche',
  'rovo-chat.view-agent.instructions-label': 'Istruzioni',
  'rovo-chat.view-agent.knowledge-label': 'Conoscenze',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} membro} other {{count,number} membri}}',
  'rovo-chat.view-agent.modal-title': 'Sfoglia gli agenti',
  'rovo-chat.view-agent.no-actions': 'Nessuna azione',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Questo agente non dispone di istruzioni personalizzate',
  'rovo-chat.view-agent.no-knowledge-added': 'Nessuna fonte di conoscenza personalizzata',
  'rovo-chat.view-agent.no-teams': 'Non fa parte di alcun team',
  'rovo-chat.view-agent.open-chat-label': 'Apri chat',
  'rovo-chat.view-agent.reactions-metadata-label': 'N. di reazioni',
  'rovo-chat.view-agent.rovo-agent-label': 'Agente Rovo',
  'rovo-chat.view-agent.teams-label': 'Team',
  'rovo-chat.view-agent.users-metadata-label': 'N. di utenti',
};
